// Auto-generated file. Do not edit manually.
// This file was generated by ./scripts/parse-ast.ts and changes will be overwritten.
// To modify this file, make changes to the corresponding Solidity contract and regenerate.
import { Address, Hex } from 'viem';

export enum EngineType {
  PERP = 0,
  SPOT = 1,
}

export enum OrderSide {
  BUY = 0,
  SELL = 1,
}

export enum ActionType {
  LinkSigner = 0,
  MatchOrders = 1,
  InitiateWithdraw = 2,
  UpdateFunding = 3,
  RevokeLinkedSigner = 4,
  LiquidateSubaccount = 5,
  FinalizeDeposit = 6,
}

export enum ProductStatus {
  PENDING = 0,
  ACTIVE = 1,
  CLOSE_ONLY = 2,
}

export interface LinkSignerMessage {
  sender: Address;
  signer: Address;
  subaccount: Hex;
  nonce: bigint;
  signedAt: bigint;
}

export interface LinkSignerAction {
  message: LinkSignerMessage;
  signature: Hex;
  signerSignature: Hex;
}

export interface RevokeLinkedSignerMessage {
  sender: Address;
  signer: Address;
  subaccount: Hex;
  nonce: bigint;
  signedAt: bigint;
}

export interface RevokeLinkedSignerAction {
  message: RevokeLinkedSignerMessage;
  signature: Hex;
}

export interface TradeOrder {
  sender: Address;
  subaccount: Hex;
  quantity: bigint;
  price: bigint;
  reduceOnly: boolean;
  side: OrderSide;
  engineType: EngineType;
  productId: number;
  nonce: bigint;
  signedAt: bigint;
}

export interface MatchOrdersAction {
  maker: TradeOrder;
  taker: TradeOrder;
  makerSignature: Hex;
  takerSignature: Hex;
  makerFee: bigint;
  takerFee: bigint;
  messageIdx: bigint;
}

export interface InitiateWithdrawMessage {
  account: Address;
  subaccount: Hex;
  token: Address;
  amount: bigint;
  nonce: bigint;
  signedAt: bigint;
}

export interface InitiateWithdrawAction {
  message: InitiateWithdrawMessage;
  signature: Hex;
  messageIdx: bigint;
}

export interface UpdateFundingAction {
  productId: number;
  fundingDeltaUsd: bigint;
  messageIdx: bigint;
}

export interface FinalizeDepositAction {
  account: Address;
  subaccount: Hex;
  token: Address;
  amount: bigint;
  initiatedTxHash: Hex;
  initiatedLogIdx: number;
  messageIdx: bigint;
}

export interface UpdateTokenParams {
  tokenName: Hex;
  depositCapacity: bigint;
  minDeposit: bigint;
  depositFee: bigint;
  withdrawFee: bigint;
  depositEnabled: boolean;
  withdrawEnabled: boolean;
}

export interface RegisterPerpProductParams {
  status: ProductStatus;
  baseTokenName: Hex;
  quoteTokenName: Hex;
  makerFee: bigint;
  takerFee: bigint;
  tickSize: bigint;
  maxQuantity: bigint;
  lotSize: bigint;
  maxLeverage: number;
  maxOpenInterest: bigint;
  pythFeedId: number;
}

export interface ExecuteMatchDigests {
  maker: Hex;
  taker: Hex;
}

export interface LiquidatedProduct {
  productId: number;
  engineType: EngineType;
  pythFee: bigint;
  sizeDelta: bigint;
  pythPriceUpdate: Hex;
  cost: bigint;
}

export interface LiquidateSubaccountAction {
  liquidatedAccount: Address;
  liquidatedSubaccount: Hex;
  products: LiquidatedProduct[];
  messageIdx: bigint;
}

// End of generated ASTs.
